import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import PatHN from "../img/pat-hn.png";
import PatVN from "../img/pat-vn.png";
import PatIdCard from "../img/pat-id-card.png";
import PatName from "../img/pat-name.png";
import PatSex from "../img/pat-sex.png";
import PatAge from "../img/pat-age.png";
import Card from "react-bootstrap/Card";
import Accordion from 'react-bootstrap/Accordion';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ip from '../ipserver';
import { useLocation } from 'react-router-dom';
import { decryptData } from "./EncryptACCESSION_NO";
function PatientInfo(){

    const ipserver = ip;


    const [ patientDetail , setPatientDetails ] = useState([{}]);
    const [loading,setLoading] = useState(true);
    const location = useLocation();
    let fetchData;

    function splitParameters(paramString) {
        const params = {};
        const accMatch = paramString.match(/Acc=([0-9]+)/); // หา Acc โดยใช้ regex
        const tableMatch = paramString.match(/Table=(.+)/); // หา Table โดยใช้ regex
        
        if (accMatch) params['Acc'] = accMatch[1]; // เก็บค่า Acc
        if (tableMatch) params['Table'] = tableMatch[1]; // เก็บค่า Table
        
        return params;
    }

    useEffect(() => {
        const fetchPatientDetails = async() => {
            try{
                // ดึงข้อมูลจาก URL ที่ประกอบด้วย hash
                const path = location.pathname.split('/').pop(); 
                const decryptedData = decryptData(path);
                // ใช้ฟังก์ชันแยกพารามิเตอร์
                const { Acc, Table } = splitParameters(decryptedData);

                const response = await axios.get(`https://${ipserver}/api/GetPatientInfo/${Acc}/${Table}`);
                setPatientDetails(response.data);
                
                
            } catch (error) {
                console.error("Error fetching patient details: ", error);
                // navigate('/worklist')
            } finally {
                setLoading(false);
            }
        };
    
        fetchPatientDetails(); 
    }, [fetchData ]);

    if (loading) {
        return <div>กำลังโหลดข้อมูล</div>
    }


    const calculateAge = (date) => {
        if (date) {
            const birthDate = new Date(date.split('T')[0]);
    
            const today = new Date();
            let ageYears = today.getFullYear() - birthDate.getFullYear();
            let ageMonths = today.getMonth() - birthDate.getMonth();
        
            if (ageMonths < 0 || (ageMonths === 0 && today.getDate() < birthDate.getDate())) {
                ageYears--;
                ageMonths += 12; 
            }
        
            if (today.getDate() < birthDate.getDate()) {
                ageMonths--;
            }
        
            return `${ageYears}Y ${ageMonths}M`;
        }
        else {
            return '';
        }
    
        
    };
    return ( 
        <>
                <Card className="mt-3 cardworklist">
                    <Card.Body>
                        <Accordion defaultActiveKey="0" flush className='accordion'>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header className='datapatientheader'>ข้อมูลคนไข้</Accordion.Header>
                                
                                <Accordion.Body>
                                <Row>
                                        <Col md={4}  >
                                            <Card className="cardbox">
                                                <Row>
                                                    <Col className="img-body" ><img className="patheadimg" src={PatHN}/></Col>
                                                    
                                                    <Col  className="detailcard">
                                                        <Row className="detaildata mt-2"><h3 className="detail-head">HN</h3></Row>
                                                        <Row className="detaildata"><h4 className="detail-body">{patientDetail[0].PATIENT_ID}</h4></Row>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>

                                        <Col md={4}>
                                            <Card className="cardbox ">
                                                <Row>
                                                    <Col className="img-body" ><img className="patheadimg" src={PatVN}/></Col>
                                                    
                                                    <Col  className="detailcard2">
                                                        <Row className="detaildata mt-2"><h5 className="detail-body">EXAM : {patientDetail[0].STUDY_DESC}  </h5></Row>
                                                        <Row className="detaildata mt-2"><h5 className="detail-body">ACC : {patientDetail[0].ACCESS_NO} </h5></Row>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>

                                        <Col md={4}>
                                            <Card className="cardbox ">
                                                <Row>
                                                    <Col className="img-body" ><img className="patheadimg" src={PatIdCard}/></Col>
                                                    
                                                    <Col  className="detailcard">
                                                        <Row className="detaildata mt-2"><h3 className="detail-head">ID CARD</h3></Row>
                                                        <Row className="detaildata"><h4 className="detail-body">{patientDetail.OTHER_PATIENT_ID}</h4></Row>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>
                                    </Row>

                                    <Row >
                                        <Col md={4} >
                                            <Card className="cardbox ">
                                                <Row>
                                                    <Col className="img-body" ><img className="patheadimg" src={PatName}/></Col>
                                                    
                                                    <Col  className="detailcard">
                                                        <Row className="detaildata mt-2"><h3 className="detail-head">NAME</h3></Row>
                                                        <Row className="detaildata"><h5 className="detail-body">{patientDetail[0].PATIENT_NAME}</h5></Row>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>

                                        <Col md={4}>
                                            <Card className="cardbox ">
                                                <Row>
                                                    <Col className="img-body"><img className="patheadimg" src={PatSex}/></Col>
                                                    
                                                    <Col  className="detailcard">
                                                        <Row className="detaildata mt-2"><h3 className="detail-head">SEX</h3></Row>
                                                        <Row className="detaildata"><h4 className="detail-body">{patientDetail[0].PATIENT_SEX === 'M' ? 'Male':'Female'}</h4></Row>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>

                                        <Col md={4}>
                                            <Card className="cardbox ">
                                                <Row>
                                                    <Col className="img-body"><img className="patheadimg" src={PatAge}/></Col>
                                                    
                                                    <Col  className="detailcard">
                                                        <Row className="detaildata mt-2"><h3 className="detail-head">AGE</h3></Row>
                                                        <Row className="detaildata"><h4 className="detail-body">{calculateAge(patientDetail[0].PATIENT_BIRTH_DTTM)}</h4></Row>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>

                        
                    </Card.Body>
                </Card>
        </>

    )
        
}

export default PatientInfo;